/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    action: PropTypes.bool,
    fluid: PropTypes.bool,
    isActive: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    action: false,
    fluid: false,
    isActive: false,
};

const TabMenuItem = (props) => {
    const classNames = [
        'c-tab-menu__item',
        props.isActive ? 'is-active' : '',
        props.action ? 'c-tab-menu__item--action' : '',
        props.fluid ? 'c-tab-menu__item--fluid' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

TabMenuItem.propTypes = propTypes;

TabMenuItem.defaultProps = defaultProps;

export default TabMenuItem;
